import { Button } from 'antd';
import React, { memo, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getFilterSetFromSearchParams } from 'components/drawers/BackOfficeFilterDrawer/getFilterSetFromSearchParams';
import { SEARCH_PARAMS } from 'constants/search-params';
import { FilterSetName } from 'store/modules/routerUtils/types';

interface Props {
  filterSetName: FilterSetName;
}

function BackOfficeFilterDrawerTriggerButton({
  filterSetName
}: Props): JSX.Element | null {
  const [searchParams, setSearchParams] = useSearchParams();
  const filterSet = useMemo(
    () => getFilterSetFromSearchParams(searchParams, filterSetName),
    [searchParams, filterSetName]
  );
  const numberOfAppliedFilters = Object.keys(filterSet).length;

  const handleClick = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.set(SEARCH_PARAMS.BACK_OFFICE.DRAWER_FILTER, filterSetName);
      return newSearchParams;
    });
  };

  if (!filterSetName) {
    return null;
  }

  return (
    <Button size="small" type="primary" ghost onClick={handleClick}>
      FILTERS{numberOfAppliedFilters ? ` · ${numberOfAppliedFilters}` : ''}
    </Button>
  );
}

export default memo(BackOfficeFilterDrawerTriggerButton);
